<!-- 直播+短视频 -->
<template>
  <div class="warp">
    <div class="banner">
      <p>直播+短视频</p>
      <span>
        直播互动引爆平台流量，短视频
        <br />随拍记录精彩生活
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="section">
      <div class="title" style="padding:1.2rem 0 .7rem">多元解决方案 解锁更多玩法</div>
      <div class="item1">
        <div class="img">
          <img src="../../assets/images/page38.jpg" />
        </div>
        <ul class="list1">
          <li>
            <span>直播+短视频</span>
            <p>用户可自主选择观看直播或短视频,打造功能更全面，互动性更强，内容形式更丰富的泛娱乐平台。</p>
          </li>
          <li>
            <span>直播</span>
            <p>视频直播、连麦互动、传播分享，丰富的直播功能，打造优质流媒体直播系统。</p>
          </li>
          <li>
            <span>直播</span>
            <p>多元化短视频解决方案，门槛更低，应用场景更丰富，快速聚集粉丝流量。</p>
          </li>
        </ul>
        <ul class="list2">
          <li>
            <img src="../../assets/images/icon69.jpg" />
            <span>
              实时交流
              <br />互动性强
            </span>
          </li>
          <li>
            <img src="../../assets/images/icon70.jpg" />
            <span>
              道具打赏
              <br />收益更高
            </span>
          </li>
          <li>
            <img src="../../assets/images/icon71.jpg" />
            <span>
              付费直播
              <br />变现渠道更丰富
            </span>
          </li>
          <li>
            <img src="../../assets/images/icon72.jpg" />
            <span>
              全民参与
              <br />门槛更低
            </span>
          </li>
          <li>
            <img src="../../assets/images/icon73.jpg" />
            <span>
              贴近生活
              <br />内容多元化
            </span>
          </li>
          <li>
            <img src="../../assets/images/icon74.jpg" />
            <span>
              短小精悍
              <br />碎片化消费
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section section1">
      <div class="title" style="padding:.7rem 0 0">极致体验功能 打造优质泛娱乐平台</div>
      <div class="item">
        <div class="subTitle">
          <i></i>
          <span>01 直播</span>
          <i></i>
        </div>
        <div class="subImg">
          <img src="../../assets/images/page40.png" />
        </div>
        <ul class="subUl">
          <li>
            <img src="../../assets/images/sinatv01.png" />
            <span>美颜特效</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv02.png" />
            <span>线上商城</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv03.png" />
            <span>录播回放</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv04.png" />
            <span>礼物打赏</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv05.png" />
            <span>付费直播</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv06.png" />
            <span>进场特效</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv07.png" />
            <span>弹幕互动</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv08.png" />
            <span>游戏互动</span>
          </li>
        </ul>
      </div>

      <div class="item">
        <div class="subTitle">
          <i></i>
          <span>02短视频</span>
          <i></i>
        </div>
        <div class="subImg">
          <img src="../../assets/images/page41.png" />
        </div>
        <ul class="subUl">
          <li>
            <img src="../../assets/images/sinatv09.png" />
            <span>热门推荐</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv10.png" />
            <span>在线录制</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv11.png" />
            <span>转发分享</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv12.png" />
            <span>线上商城</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv13.png" />
            <span>趣味特效</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv14.png" />
            <span>海量配乐</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv15.png" />
            <span>点赞评论</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv16.png" />
            <span>视频广告</span>
          </li>
        </ul>
      </div>

      <div class="item">
        <div class="subTitle">
          <i></i>
          <span>03管理后台</span>
          <i></i>
        </div>
        <div class="subImg">
          <img src="../../assets/images/page42.png" />
        </div>
        <ul class="subUl">
          <li>
            <img src="../../assets/images/sinatv17.png" />
            <span>用户管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv18.png" />
            <span>数据分析</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv19.png" />
            <span>主播管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv20.png" />
            <span>广告管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv21.png" />
            <span>内容管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv22.png" />
            <span>提现管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv23.png" />
            <span>频道管理</span>
          </li>
          <li>
            <img src="../../assets/images/sinatv24.png" />
            <span>榜单管理</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="section section3">
      <div class="title" style="padding:.7rem 0 8.8rem">丰富变现形式 加速商业化进程</div>
      <ul class="list3">
        <li>
          <img src="../../assets/images/sinatv25.png" />
          <div>
            <span>主播收益分成</span>
            <p>与主播共享打赏、现金、道具收益、网红KOL、收益增值数以千万计</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/sinatv26.png" />
          <div>
            <span>广告收益</span>
            <p>直播及短视频广告曝光更强。精准的数据分析，助力广告内容精准投放</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/sinatv27.png" />
          <div>
            <span>会员增值服务</span>
            <p>会员等级与权益关联，收取增值服务费用，如去广告、专属道具等</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/sinatv28.png" />
          <div>
            <span>电商销售收益</span>
            <p>对接线上商城，视频轻松带动购物氛围，刺激粉丝消费 ，快速获得收益</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/sinatv29.png" />
          <div>
            <span>付费直播收益</span>
            <p>私密付费直播，门票及打赏收益更高，轻松实现流量变现</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/sinatv30.png" />
          <div>
            <span>更多变现渠道</span>
            <p>更多变现模式，等待您的探索……</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="section section4">
      <div class="title" style="padding:.7rem 0 0rem">专业技术服务 品质更有保障</div>
      <ul class="list4">
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv31.png" />
          </div>
          <div class="right">
            <span>多元化解决方案</span>
            <p>支持直播+短视频、直播、短视频多种方案，精准匹配用户需求，解锁更多玩法</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv32.png" />
          </div>
          <div class="right">
            <span>跨平台互通</span>
            <p>支持Android、iOS主流平台，接入微信公众号；支持一对一、一对多互动直播</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv33.png" />
          </div>
          <div class="right">
            <span>完美的互动直播体验</span>
            <p>卓越的音视频质量，支持同时收取3路语音，720P高清视频，保证高质量音视频通信</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv34.png" />
          </div>
          <div class="right">
            <span>系统安全稳定</span>
            <p>超低延时，内容秒传，端到端演示小于400ms</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv35.png" />
          </div>
          <div class="right">
            <span>品牌合作 流量分发</span>
            <p>与腾讯云、阿里云合作，直播质量有保障。绿茶提供统一大流量订购，资费更优惠</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/sinatv36.png" />
          </div>
          <div class="right">
            <span>高并发解决方案</span>
            <p>针对不同级别高并发有不同的解决方案。助您轻松应对平台瞬间高并发业务</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="section section5">
      <div class="title" style="padding:.7rem 0 0rem">应用场景</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sinatv",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/sinatvBanner.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #e6318b;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      display: block;
      line-height: .9rem;
    }
  }
  .section {
    .title {
      font-size: 0.52rem;
      color: #000;
      text-align: center;
    }
    .item1 {
      img {
        img {
          width: 100%;
        }
      }
      .list1 {
        padding: 0.5rem;
        li {
          padding: 0.3rem 0;
          span {
            font-size: 0.4rem;
            color: #905efb;
          }
          p {
            font-size: 0.34rem;
            padding-top: 0.1rem;
          }
        }
      }
      .list2 {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0.8rem;
        li {
          width: 33.333333%;
          text-align: center;
          padding: 0.3rem 0;
          img {
            width: 1.5rem;
            height: 1.5rem;
          }
          span {
            display: block;
            font-size: 0.34rem;
            line-height: 0.5rem;
            padding-top: 0.1rem;
          }
        }
      }
    }
  }
  .section1 {
    background: url("../../assets/images/page39.jpg") repeat;
    background-size: 2rem 2rem;
    .item {
      .subTitle {
        text-align: center;
        padding: 0.3rem;
        span {
          font-weight: bold;
          font-size: 0.44rem;
          display: inline-block;
          padding: 0 0.2rem;
          vertical-align: middle;
        }
        i {
          display: inline-block;
          width: 0.4rem;
          height: 0.1rem;
          background-color: #262e43;
          vertical-align: middle;
        }
      }
      .subImg {
        img {
          width: 100%;
        }
      }
      .subUl {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0.8rem;
        li {
          width: 25%;
          text-align: center;
          font-size: 0.34rem;
          line-height: 0.6rem;
          padding: 0.2rem 0;
          img {
            width: 0.6rem;
          }
        }
      }
    }
  }
  .section3 {
    background: url("../../assets/images/page43.jpg") no-repeat left 1.4rem
      #f4f9f3;
    background-size: 100% auto;
    margin-top: 1.5rem;
    .list3 {
      padding-bottom: 0.8rem;
      li {
        display: flex;
        padding: 0.2rem 0.3rem 0.2rem 0.1rem;
        img {
          width: 1.2rem;
          height: 1.2rem;
          margin-top: -0.15rem;
        }
        span {
          font-weight: 500;
          font-size: 0.44rem;
          line-height: 0.8rem;
        }
        p {
          font-size: 0.34rem;
          color: #666;
        }
      }
    }
  }
  .section4 {
    margin-top: 1rem;
    .list4 {
      padding: 0.4rem;
      li {
        display: flex;
        height: 3.5rem;
        margin-top: 0.5rem;
        .left {
          width: 2.8rem;
          border-radius: 0.1rem 0 0 0.1rem;
          background-image: linear-gradient(
            45deg,
            rgb(139, 89, 249) 0%,
            rgb(174, 64, 241) 100%
          );
          img {
            width: 1.5rem;
            margin-left: 0.65rem;
            margin-top: 1rem;
          }
        }
        .right {
          flex: 1;
          border-radius: 0 0.1rem 0.1rem 0;
          border: 1px dashed #aa43f2;
          border-left: 0.1rem solid #d4a1f8;
          padding: .6rem .5rem .6rem;
          span{
            font-size: .44rem;
            font-weight: 500;
            padding-bottom: .1rem;
            display:block;
          }
          p{
            font-size: .34rem;
            color: #666;
          }
        }
      }
      li:nth-child(2n) {
        .left {
          background-image: linear-gradient(
            45deg,
            rgb(234, 167, 15) 0%,
            rgb(244, 206, 103) 100%
          );
        }
        .right {
          border: 1px dashed #eaa913;
          border-left: 0.1rem solid #fee19f;
        }
      }
    }
  }
  .section5{
    background: url('../../assets/images/page44.jpg') no-repeat left top;
    background-size: 100% auto;
    height: 7.3rem;
    margin: .8rem 0 -1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/sinatv.vue